export default __webpack_public_path__ + "static/media/plugins.a7a8404d.svg";